import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const icons = [
  'directory-icon',
  'factory-icon',
  'person-icon',
  'tx-history-icon',
  'wallet-icon',
  'lock-icon',
  'paypal-icon',
  'arrow',
  'tokentory-icon',
  'close-icon',
  'certified-icon',
  'default-token',
  'transaction-icon',
];

@Injectable({
  providedIn: 'root'
})
export class IconsService {

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.loadIcons(icons, '/assets/icons');
  }

  private loadIcons(iconKeys: string[], iconUrl: string): void {
    iconKeys.forEach(key => {
      this.matIconRegistry.addSvgIcon(key, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${key}.svg`));
    });
  }
}
